<template>
    <label for="country" class="form-label">
        {{ countryLabel }} <span v-if="required" class="text-danger">*</span>
    </label>
    <select
        id="country"
        :name="countryName"
        class="form-control"
        :class="{ 'is-invalid': countryError }"
        v-model="selectedCountry"
        :required="required"
    >
        <option value="">{{ selectText }}</option>
        <option
            v-for="(label, value) in countryOptions"
            :key="value"
            :value="value"
        >
            {{ label }}
        </option>
    </select>
    <small v-if="helpText" class="form-text text-muted">{{ helpText }}</small>
    <div v-if="countryError" class="invalid-feedback">{{ countryError }}</div>

    <div v-show="selectedCountry === 'other'">
        <label for="country_other" class="form-label">
            {{ countryOtherLabel }} <span class="text-danger">*</span>
        </label>
        <input
            id="country_other"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': countryOtherError }"
            :name="countryOtherName"
            v-model="otherCountryValue"
            :required="selectedCountry === 'other'"
        >
        <div v-if="countryOtherError" class="invalid-feedback">{{ countryOtherError }}</div>
    </div>
</template>

<script>
export default {
    name: 'CountrySelectVertical',
    props: {
        countryName: {
            type: String,
            default: 'country'
        },
        countryOtherName: {
            type: String,
            default: 'country_other'
        },
        countryLabel: {
            type: String,
            required: true
        },
        countryOtherLabel: {
            type: String,
            required: true
        },
        selectText: {
            type: String,
            required: true
        },
        helpText: {
            type: String,
            default: ''
        },
        countryOptions: {
            type: Object,
            required: true
        },
        oldCountry: {
            type: String,
            default: ''
        },
        oldCountryOther: {
            type: String,
            default: ''
        },
        countryError: {
            type: String,
            default: ''
        },
        countryOtherError: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedCountry: this.oldCountry,
            otherCountryValue: this.oldCountryOther
        }
    },
    watch: {
        selectedCountry(newValue) {
            if (newValue !== 'other') {
                this.otherCountryValue = '';
            }
        }
    }
}
</script>
